import React, { useEffect, useState, useRef } from 'react';
import './HRLServicesWildfires.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import SubscribeForm from '../SubscribeFormFolder/SubscribeForm';
import { DownloadableDocs } from '../HRLServicesUtility/HRLServicesUtility';

import {
  LazyLoadImage,
  LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets
// Background video
const BannerBg = require('./videos/wildfire-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/wildfire-lazyload.png');

// Images
import wildfireBg2 from './img/wildfire-bg2.png'
import foreFlightLogo from './img/foreflight-white.png'
import ipad from './img/ipad-foreflight.png'
import papers from './img/papers.png'
import successCase1 from './img/PilotSC1.jpg'

// Swiper pics
import swiperPic1 from '../HomeFolder/img/Marta.png'
import swiperPic2 from './img/FFS-round.png'
import swiperPic3 from '../HomeFolder/img/John.png'

// Hero button images
import whiteTree from './img/white-fire-tree.png'
import blueTree from './img/blue-fire-tree.png'
import whiteHeli from './img/white-heli.png'
import blueHeli from './img/blue-heli.png'

// Gifs
import lightningGif from './gifs/Website.gif'
import fireGif from './gifs/Fire.gif'
import futureGif from './gifs/Future.gif'

// Icons
import { FaArrowRight } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";

// Swiper imports
import { SwiperCardProps } from "../HomeFolder/home"

type OptionType = 'lightning' | 'fire' | 'future';


// Swiper Card
export interface PilotSuccessProps {
  title: string;
  date: string;
  image_url: string;
}

const PilotCards: React.FC<PilotSuccessProps> = ({ image_url, title, date }) => (
  <div className="pilot-hero-section">
    <div className="pilot-card-wrapper">
      <p className='pilot-info'>{title} ({date})</p>
      <img className="pilot-image" alt="hero background" src={image_url} />
    </div>
  </div>
);



const HRLServicesWildfires = () => {

  // Pilot Success Cases Section

  const [loading, setLoading] = useState<boolean>(true);
  const [pilotCases, setPilotCase] = useState<PilotSuccessProps[]>([]);
  const [error1, setError1] = useState<string | null>(null);

  const fetchPilotSuccess = async () => {
    try {
      const response = await fetch('/api/pilot_success/', {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data: PilotSuccessProps[] = await response.json();
      setPilotCase(data); // Assign the fetched posts to state
    } catch (err) {
      // Type assertion to 'Error' to access the message property
      if (err instanceof Error) {
        setError1(err.message); // Handle error
      } else {
        setError1('An unknown error occurred'); // Fallback for unknown errors
      }
    } finally {
      setLoading(false); // End loading state
    }
  };

  useEffect(() => {
    fetchPilotSuccess();
    // console.log(pilotCases)
  }, []); // Empty dependency array to run once on mount

  // Section for the video and its lazyLoad functionality
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const SwiperCard: React.FC<SwiperCardProps> = ({ imageSrc, name, position, quote }) => (
    <div className='swiper-info addon-card'>
      <div className='swiper-pic-and-name'>
        <img className="swiper-pic" alt={`${name} headshot`} src={imageSrc} />
        <div className='swiper-nameAndPosition'>
          <h1>{name}</h1>
          <h2>{position}</h2>
        </div>
      </div>
      <p className='the-h2'>{quote}</p>
    </div>
  );

  /* Section for controlling how many testimonials there are per view */
  const [slidesPerView, setSlidesPerView] = useState(1);

  useEffect(() => {
    const calculateSlides = () => {
      const containerWidth = window.innerWidth * 0.95;

      // Dynamically assign card width based on breakpoints
      let cardWidth;

      if (window.innerWidth >= 1450) {
        cardWidth = 640; // 40rem
      } else if (window.innerWidth >= 1040) {
        cardWidth = 448; // 28rem
      } else if (window.innerWidth >= 450) {
        cardWidth = 352; // 22rem
      } else {
        cardWidth = 300; // 22rem
      }

      const spacing = 50; // matches spaceBetween in Swiper
      const raw = (containerWidth + spacing) / (cardWidth + spacing);
      const adjustedSlides = Math.floor(raw * 100) / 100;

      setSlidesPerView(adjustedSlides);
    };

    calculateSlides();
    window.addEventListener("resize", calculateSlides);

    return () => window.removeEventListener("resize", calculateSlides);
  }, []);

  // Hero button hover logic
  const [hoveredCard, setHoveredCard] = useState<"land" | "air" | null>(null);
  const wildfireRef = useRef<HTMLHeadingElement>(null);
  const foreflightRef = useRef<HTMLDivElement>(null);

  const [selected, setSelected] = useState<OptionType>('lightning');

  const renderGif = () => {
    switch (selected) {
      case 'lightning':
        return <img src={lightningGif} alt="Lightning" className="laptop-gifs" />;
      case 'fire':
        return <img src={fireGif} alt="Fire" className="laptop-gifs" />;
      case 'future':
        return <img src={futureGif} alt="Future" className="laptop-gifs" />;
      default:
        return null;
    }
  };

  // Downloadable content code
  const [doc, setDoc] = useState<DownloadableDocs[]>([]);
  const [showInput, setShowInput] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const fetchDocs = async () => {
    try {
      const response = await fetch('/api/downloadable_pdf/', {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data: DownloadableDocs[] = await response.json();
      setDoc(data); // Assign the fetched posts to state
    } catch (err) {
      // Type assertion to 'Error' to access the message property
      if (err instanceof Error) {
        setError(err.message); // Handle error
      } else {
        setError('An unknown error occurred'); // Fallback for unknown errors
      }
    }
  };

  useEffect(() => {
    fetchDocs();
  }, []); // Empty dependency array to run once on mount

  const handleDownloadClick = () => {
    setShowInput(true);
  };

  const fetchCsrfToken = async () => {
    const response = await fetch('/api/csrf-token/', {
      method: 'GET',
      credentials: "same-origin", // include cookies in the request
    });

    if (response.ok) {
      const data = await response.json();
      return data.csrfToken; // Return the CSRF token
    } else {
      console.error('Failed to fetch CSRF token');
      return null;
    }
  };

  const handleWildfireDownloadOnly = async (e: React.FormEvent) => {
    e.preventDefault();

    const csrfToken = await fetchCsrfToken();
    if (!csrfToken) return;

    try {
      if (!email) return;

      // Send email to backend for "wildfire" subscription without triggering automations
      const response = await fetch('/api/subscribe/', {
        method: 'POST',
        credentials: "same-origin",
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken
        },
        body: JSON.stringify({ email, industry: 'wildfire', skipNewsletter: true }), // add a flag
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Subscription failed');

      setSubmitted(true);
      setError('');
      setShowInput(false);

      // Trigger PDF download immediately in new tab
      const mostRecentWildfireDoc = doc
        .filter(d => d.type === 'WILDFIRE')
        .sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime())[0];

      if (mostRecentWildfireDoc?.file) {
        window.open(mostRecentWildfireDoc.file, '_blank', 'noopener,noreferrer');
      }

      // Reset email after 6 seconds
      setTimeout(() => {
        setSubmitted(false);
        setEmail('');
      }, 6000);

    } catch (err: any) {
      console.error(err);
      setError(err.message || 'Something went wrong.');
    }
  };

  return (
    <div className="detector-container">

      {/* Cover Section */}
      <div className="detector-hero-section">
        {!isVideoLoaded && (
          <LazyLoadComponent
            placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
          >
            <LazyLoadImage
              src={BannerBg_LazyLoadImg}
              alt="="
              className="hero-image"
            />
          </LazyLoadComponent>
        )}

        <video
          className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
          src={BannerBg}
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={() => setIsVideoLoaded(true)}
        />

        <div className="dark-overlay"></div> {/* ← Overlay */}

        <div className="wildfire-hero-info-wrapper">
          <h1><strong> Fire Agency <br />Solutions</strong></h1>

          <div className='land-air-cards'>
            <div
              className='land-air-card2 opa'
              onMouseEnter={() => setHoveredCard('land')}
              onMouseLeave={() => setHoveredCard(null)}
              onClick={() => foreflightRef.current?.scrollIntoView({ behavior: 'smooth' })}
            >
              <img
                className="land-air-img2"
                alt="heli"
                src={hoveredCard === 'land' ? blueHeli : whiteHeli}
              />
              <p>Aerial <br /> Fleet Crew</p>
            </div>
            <div
              className='land-air-card1 opb'
              onMouseEnter={() => setHoveredCard('air')}
              onMouseLeave={() => setHoveredCard(null)}
              onClick={() => {
                if (wildfireRef.current) {
                  const yOffset = -45; // scroll 80px above the element
                  const y = wildfireRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                  window.scrollTo({ top: y, behavior: 'smooth' });
                }
              }}
            >
              <img
                className="land-air-img"
                alt="tree"
                src={hoveredCard === 'air' ? blueTree : whiteTree}
              />
              <p>Land<br />Management</p>
            </div>
          </div>
        </div>
      </div>

      {/* Land Management Section */}
      <div className="high-risk-section">
        <div className='high-risk-info-wrapper'>
          <h1 className='the-h1'>Wildfires Identified in 40 seconds</h1>

          <h2 className='the-h2'>Wildfires are becoming increasingly intense and widespread each year—yet average
            detection times <span className='glow-blue'> still lag at over 24 hours</span>. FNN™’s proprietary
            High-Risk-Lightning™ (HRL™) detector identifies and classifies a key driver behind the most destructive fire outbreaks within seconds. These
            <span className='glow-blue'> uniquely hazardous lightning</span> events are defined by their prolonged duration
            and extreme thermal impact, making them a leading indicator of wildfire acreage burned.</h2>

          <Link to="/hrl-detector" className='the-button2'>
            <span>Explore services</span>
          </Link>
        </div>
      </div>

      <div className='foreflight-section-parent' ref={foreflightRef}>

        <div className='absolute-foreflight'>

          <div className='absolute-foreflight-left'>
            <div className='foreflight-card'>
              <img className="" alt="card" src={foreFlightLogo} />
            </div>

            <div className='foreflight-info'>
              <div className='action-info-wrapper text-under-text'>
                <h1 className='the-h1'>FNN™ Foreflight for Pilots and Emergency Teams </h1>

                <h2 className='the-h2'>FNN™’s HRL™ data seamlessly <span className='glow-blue'> integrates into Foreflight</span>
                  , as used by Florida Forest Service (FFS). HRL™ data is being leveraged by every pilot in the Florida Forest Service,
                  cutting down time in the sky, saving cost, increasing safety, and finding wildfires <span className='glow-blue'> 10x
                    faster</span>.</h2>

                <Link to="/contact" className='the-button'>
                  <span>Learn More</span>
                </Link>
              </div>
            </div>
          </div>

          <img className="ipad-image" alt="card" src={ipad} />


        </div>


      </div>

      {/* Pilot Success Case Section */}
      <div className="high-risk-section desktop-margin">
        <div className='high-risk-info-wrapper adj-padding'>
          <h1 className='the-h1 text-under-text2'>Pilot Success Cases</h1>

        </div>
      </div>



      {/* <div className="pilot-hero-section">
        <p className='pilot-info'>ForeFlight | Red Horse Fire #231 (4/2/25)</p>
        <img className="pilot-image" alt="hero background" src={successCase1} />
      </div> */}

      {loading ? (
        <div className="pilot-loading-message">Loading success cases...</div>
      ) : error1 ? (
        <div className="pilot-error-message">Failed to load data: {error1}</div>
      ) : (
        <Swiper
          slidesPerView={1}
          spaceBetween={0}
          pagination={{ clickable: true }}
          centeredSlides={false}
          modules={[Pagination]}
          className="mySwiper"
        >
          {pilotCases.map((caseData, index) => (
            <SwiperSlide key={index}>
              <PilotCards
                image_url={caseData.image_url}
                title={caseData.title}
                date={new Date(caseData.date).toLocaleDateString('en-US')}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}




      {/* Desktop Section */}
      <div className="high-risk-section">
        <img className="wildfire-image2" alt="action background" src={wildfireBg2} />
      </div>

      <div className="high-risk-section" >
        <div className='high-risk-info-wrapper'>
          <h1 className='the-h1' ref={wildfireRef}>FNN™ Dashboards for Wildfire Data</h1>

          <h2 className='the-h2'>FNN™ detects dangerous lightning events using its proprietary <span className='glow-blue'> High
            Risk Lightning™ (HRL™) detection systems</span>, combining sensor data with real-time environmental inputs. By analyzing
            over <span className='glow-blue'> 35 variables through advanced AI signal processing</span>, FNN™ pinpoints—within 100
            feet—the most likely location of a lightning-ignited wildfire.
          </h2>
        </div>
      </div>

      <div className="laptop-wrapper">
        <div className='laptop-inner-content'>
          {renderGif()}

          <div className="laptop-options">
            <div
              className={`laptop-option-card ${selected === 'lightning' ? 'active' : ''}`}
              onClick={() => setSelected('lightning')}
            >
              <h1>Lightning Data</h1>
              <p>FNN™ detects High-Risk-Lightning™ Data and colorizes based on risk.</p>
            </div>

            <div
              className={`laptop-option-card ${selected === 'fire' ? 'active' : ''}`}
              onClick={() => setSelected('fire')}
            >
              <h1>Wildfires</h1>
              <p>FNN™ monitors wildfires growth and maps the burn scar for future analysis.</p>
            </div>

            <div
              className={`laptop-option-card ${selected === 'future' ? 'active' : ''}`}
              onClick={() => setSelected('future')}
            >
              <h1>Future Insights</h1>
              <p>FNN™ can forecast future HRL™ locations before a dangerous storm passes.</p>
            </div>
          </div>
        </div>
      </div>

      {/* White Paper Section */}
      <div className='wildfire-section-parent'>
        <div className='wildfire-card'>
          <div className='wildfire-info-wrapper'>
            <h1 className='the-wild-h1'>FNN™ Wildfire White Paper</h1>

            <h2 className='the-h2'>Download FNN’s whitepaper to discover how lightning affects forestry and land
              management across multiple states where HRL™ sensors are deployed—helping to protect lives, property,
              and biodiversity.</h2>

            {submitted ? (
              <div className="download-message">
                <h1>Download successful!</h1>
              </div>
            ) : showInput ? (
              <form className="download-input-wrapper" onSubmit={handleWildfireDownloadOnly}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="subs-input"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="the-paper-button" type="submit">
                  Download <FaArrowRight />
                </button>
              </form>
            ) : (
              <button className="the-paper-button" onClick={handleDownloadClick}>
                Download <FaArrowRight />
              </button>
            )}
          </div>

          <div className='papers-and-download'>
            <img className="papers-image" alt="action background" src={papers} />
            <button
              className='paper-download-button'
              onClick={handleDownloadClick}>
              <FiDownload className='dw-icon' />
            </button>
          </div>


        </div>
      </div>

      {/* Success Cases Section */}
      <h1 className='the-h1-title'>Success Cases</h1>

      <Swiper
        slidesPerView={slidesPerView}
        spaceBetween={50}
        pagination={{ clickable: true }}
        initialSlide={1}
        centeredSlides={true}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <SwiperCard
            imageSrc={swiperPic1}
            name="Dr. Marta Yebra"
            position="Australian Bushfire Initiative"
            quote="“Lightning ignition was responsible for over 90% of the area burned in the 2020 
                  Black Summer fires. We need the FNN™ detectors and service nationally. We placed an order”."
          />
        </SwiperSlide>

        <SwiperSlide>
          <SwiperCard
            imageSrc={swiperPic2}
            name="Florida Forest Service"
            position="June 2024"
            quote="Bee Box 2 Fire found by a FFS pilot using FNN™’s HRL™ Data to accurately locate the lightning strike 
            that started the fire with .07 mile accuracy between the strike and the reported fire location. “Using the FNN™
            HRL™  layer made my flight planning easier and quicker to locate those fires started by lightning”. "
          />
        </SwiperSlide>

        <SwiperSlide>
          <SwiperCard
            imageSrc={swiperPic3}
            name="John Raulerson"
            position="Florida Chief of Forest Protection"
            quote="“We currently house 10 FNN™ detectors and use the AI-based HRL™ 
                  service. We aim to continue to facilitate the implementation”."
          />
        </SwiperSlide>

      </Swiper>

      <SubscribeForm />

    </div>
  )
}

export default HRLServicesWildfires